import { render, staticRenderFns } from "./BillProductVatTable.vue?vue&type=template&id=ca1aa61a"
import script from "./BillProductVatTable.vue?vue&type=script&lang=js"
export * from "./BillProductVatTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports